<template>
  <div class="block-gallery">
    <figure v-for="filename in block.content.images" :key="filename">
      <Image :filename="filename" :context="context" sizes="50vw" />
    </figure>
  </div>
</template>

<script setup>
defineProps(['block', 'context'])
</script>

<style scoped>
.block-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
  gap: 0.5rem;
}

.block-gallery img { width: 100%; aspect-ratio: 4/3; object-fit: cover; }
</style>
